const ANONYMOUS_POST_TYPE = "PT010";
const STANDARD_OR_HIGHER = new Set(["standard", "premium"]);

const isStandardOrHigherMembership = (membership) => {
    if (!membership || typeof membership !== "string") return false;
    return STANDARD_OR_HIGHER.has(membership.toLowerCase());
};

const shouldShowWriterMedal = (post) => {
    if (!post || post.post_type === ANONYMOUS_POST_TYPE) return false;
    return isStandardOrHigherMembership(post.post_writer_membership);
};

export { isStandardOrHigherMembership, shouldShowWriterMedal };
